export const numCubeFaces = 6;

export const mouseEventName = {
    CLICK: "click",
    HOVER: "hover",
};
